module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    }
  }, [(_vm.isLogined) ? _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "router-fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('transition', {
    on: {
      "after-enter": _vm.afterEnter,
      "before-enter": _vm.beforeEnter
    }
  }, [(_vm.showMoveImg) ? _c('div', {
    staticClass: "move_img",
    style: ({
      left: (_vm.cartPositionL - 10) + 'px',
      top: (_vm.cartPositionT - 10) + 'px'
    })
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.moveImgUrl
    }
  })])]) : _vm._e()])], 1) : _c('transition', {
    attrs: {
      "name": "router-fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear",
    staticStyle: {
      "height": "1px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('app-footer', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5bb7adc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 791
// module chunks = 2